module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: _vm.classes,
    on: {
      "mouseenter": _vm.$_onSubMenuMouseenter,
      "mouseleave": _vm.$_onSubMenuMouseleave
    }
  }, [_c('div', {
    ref: "reference",
    class: (_vm.prefixMenuClass + "__submenu-title"),
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$_onSubMenuClick($event)
      }
    }
  }, [_vm._t("title"), _vm._v(" "), _c('i', {
    class: [_vm.prefixMenuClass + '__submenu-title-icon']
  })], 2), _vm._v(" "), (_vm.mode === 'vertical' && _vm.openPosition === 'down') ? [_c('t-collapse-transition', [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.opened),
      expression: "opened"
    }],
    class: _vm.submenuClass
  }, [_vm._t("default")], 2)])] : _c('transition', {
    attrs: {
      "name": _vm.transitionName
    }
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.opened),
      expression: "opened"
    }],
    class: _vm.rightModeMenuClass,
    staticStyle: {
      "margin-top": "0"
    },
    style: (_vm.dropStyle),
    attrs: {
      "placement": "bottom"
    }
  }, [_vm._t("default")], 2)])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7952cef8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/submenu.vue
// module id = 388
// module chunks = 0